// src/ReactivateModal.js
import React, { useState } from 'react';

function ReactivateModal({ onClose, onConfirm }) {
  const [reason, setReason] = useState('');
  const [newDeadline, setNewDeadline] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason && newDeadline) {
      onConfirm(reason, newDeadline);
    } else {
      alert("Por favor, preencha a justificativa e o novo prazo.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg w-full max-w-md shadow-2xl space-y-4">
        <h2 className="text-xl font-bold">Reativar Projeto</h2>
        <div>
          <label className="block text-sm font-medium text-gray-700">Justificativa da Reativação</label>
          <textarea 
            className="w-full p-2 border rounded mt-1" 
            rows="3"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Novo Prazo Final</label>
          <input 
            type="date" 
            className="w-full p-2 border rounded mt-1"
            value={newDeadline}
            onChange={(e) => setNewDeadline(e.target.value)}
            required
          />
        </div>
        <div className="flex justify-end gap-2 pt-4 border-t">
          <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600">Cancelar</button>
          <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">Confirmar Reativação</button>
        </div>
      </form>
    </div>
  );
}
export default ReactivateModal;